import type { Waypoint } from '../types'

export const WP: Waypoint[] = [
  { n: 'HOME', l: '00', beat: 'home', x: 0, y: 80, z: 1.05, w: 1220, h: 560, zmax: 1.05 },
  { n: 'THE PROBLEM', l: '01', beat: 'the gap', x: -1535, y: 525, w: 1090, h: 480, zmax: 0.8 },
  { n: 'WHY NOW', l: '02', beat: 'physical ai', x: -1575, y: -745, w: 990, h: 460, zmax: 0.8 },
  { n: 'THE FOUNDATION', l: '03', beat: 'the stack', x: 1469, y: -150, w: 1200, h: 940, zmax: 0.8 },
  { n: 'STUDIO', l: '04', beat: 'workflows', x: 2999, y: 320, w: 1120, h: 730, zmax: 0.74 },
  { n: 'RUNTIME VS COMPILE TIME', l: '05', beat: 'architecture', x: 2999, y: 1520, w: 1240, h: 780, zmax: 0.74 },
  { n: 'THE DEVELOPER LOOP', l: '06', beat: 'workflow', x: 1400, y: 1330, w: 1200, h: 420, zmax: 0.8 },
  { n: 'THREE COMPONENTS', l: '07', beat: 'modules', x: -90, y: 1322, w: 760, h: 620, zmax: 0.78 },
  { n: 'LIVE MODULES', l: '08', beat: 'live updates', x: 2650, y: -1040, w: 1080, h: 700, zmax: 0.74 },
  { n: 'WHO OWNS WHAT', l: '09', beat: 'licence', x: 950, y: 2300, w: 900, h: 520, zmax: 0.8 },
  { n: 'COME BUILD', l: '10', beat: 'links', x: 0, y: 2405, w: 900, h: 360, zmax: 0.95 },
]
